module.exports = __webpack_public_path__ + "img/list_harga.ab169b79.png";